import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "space-y-4 mb-3"
};
const _hoisted_2 = {
  class: "bg-slate-50 px-4 py-3 border-b border-slate-200 flex items-center justify-between"
};
const _hoisted_3 = {
  class: "flex items-center gap-3"
};
const _hoisted_4 = {
  class: "font-medium text-slate-900"
};
const _hoisted_5 = {
  key: 0,
  class: "px-2 py-0.5 bg-slate-200 text-slate-500 rounded text-xs font-medium"
};
const _hoisted_6 = {
  class: "flex items-center gap-2"
};
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_8 = {
  class: "form-switch"
};
const _hoisted_9 = ["checked", "onChange"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"
};
const _hoisted_12 = ["onUpdate:modelValue", "disabled"];
const _hoisted_13 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_14 = {
  class: "flex items-center gap-6 mb-3"
};
const _hoisted_15 = {
  key: 0,
  class: "pl-4 space-y-3"
};
const _hoisted_16 = {
  class: "flex items-center gap-3"
};
const _hoisted_17 = {
  class: "flex items-center gap-3"
};
const _hoisted_18 = ["onUpdate:modelValue", "disabled"];
const _hoisted_19 = {
  key: 1,
  class: "pl-4 flex items-center gap-3"
};
const _hoisted_20 = {
  key: 2,
  class: "pl-4 flex items-center gap-3"
};
const _hoisted_21 = {
  class: "flex items-center gap-6 mt-3"
};
const _hoisted_22 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_23 = ["onUpdate:modelValue", "disabled"];
const _hoisted_24 = {
  key: 1,
  class: "text-xs text-slate-500"
};
import { watch } from 'vue';
import { useUserStore } from '@/stores/user';
import { getUser } from '@/api/user';
import { getDept } from '@/api/dept';
import UserSelector from '@/components/UserSelector/index.vue';
import { toggleOrderServiceReminderStatus, deleteOrderServiceReminder } from '@/api/plan';
export default {
  __name: 'OrderServiceRemindersEditor',
  props: {
    // 提醒行数组（v-model:rows，行内字段可改，数组本身通过 update:rows 替换）
    rows: {
      type: Array,
      required: true
    },
    // 订单执行人ID（默认接收人预填用）
    executorId: {
      type: [Number, String],
      default: null
    },
    // 锁定模式：提醒启用开关不可关闭，仅剩一条时隐藏删除按钮（订单级选择「需要」时由父组件传入）
    locked: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:rows', 'touched'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const weekDayOptions = [{
      label: '周一',
      value: 1
    }, {
      label: '周二',
      value: 2
    }, {
      label: '周三',
      value: 3
    }, {
      label: '周四',
      value: 4
    }, {
      label: '周五',
      value: 5
    }, {
      label: '周六',
      value: 6
    }, {
      label: '周日',
      value: 7
    }];
    const emitTouched = () => emit('touched');
    let localKeySeq = 0;
    const nextLocalKey = () => `sr_${Date.now()}_${localKeySeq++}`;

    // 默认接收人：当前登录用户（订单创建人）+ 执行人 + 执行人部门 leader
    const resolveDefaultReceivers = async () => {
      const receivers = [];
      const userStore = useUserStore();
      const currentUserId = userStore.userInfo?.userId ?? userStore.userInfo?.id;
      if (currentUserId) receivers.push(Number(currentUserId));
      const executorId = props.executorId ? Number(props.executorId) : null;
      if (executorId) {
        receivers.push(executorId);
        try {
          const executor = await getUser(executorId);
          const deptId = executor?.deptId;
          if (deptId) {
            const dept = await getDept(deptId);
            const leaderId = dept?.leaderUserId ? Number(dept.leaderUserId) : null;
            if (leaderId && !receivers.includes(leaderId)) receivers.push(leaderId);
          }
        } catch (e) {
          console.error('获取执行人部门负责人失败，按无负责人处理', e);
        }
      }
      return receivers;
    };
    const addReminder = async () => {
      const receivers = await resolveDefaultReceivers();
      const newRow = {
        _localKey: nextLocalKey(),
        enabled: true,
        reminderItem: '',
        receiverUserIds: receivers,
        repeatType: 'WEEKLY',
        firstReminderTime: '',
        repeatIntervalValue: 1,
        repeatIntervalUnit: 'DAY',
        weekDay: 1,
        monthDay: 1,
        remindTime: '09:30:00',
        endType: 'COUNT',
        maxReminderCount: 10
      };
      emit('update:rows', [...props.rows, newRow]);
      emitTouched();
    };
    const toggleReminder = async reminder => {
      const newEnabled = reminder.enabled === false;
      if (reminder.id) {
        try {
          await toggleOrderServiceReminderStatus(reminder.id, newEnabled);
          reminder.enabled = newEnabled;
        } catch (error) {
          console.error('切换订单服务提醒状态失败', error);
          return;
        }
      } else {
        reminder.enabled = newEnabled;
      }
      emitTouched();
    };
    const removeReminder = async index => {
      const reminder = props.rows[index];
      if (reminder?.id) {
        try {
          await deleteOrderServiceReminder(reminder.id);
        } catch (error) {
          console.error('删除订单服务提醒失败', error);
          return;
        }
      }
      emit('update:rows', props.rows.filter((_, i) => i !== index));
      emitTouched();
    };

    // 锁定模式（用户选择「需要」服务提醒）下至少保留一条且全部保持启用：
    // 进入锁定时若无任何提醒则自动补一条默认行；历史遗留的"已关闭"提醒在本地恢复启用（保存时全删重建随命令生效）
    watch(() => props.locked, val => {
      if (!val) return;
      let restored = false;
      for (const row of props.rows) {
        if (row.enabled === false) {
          row.enabled = true;
          restored = true;
        }
      }
      if (restored) emitTouched();
      if (props.rows.length === 0) {
        addReminder();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_time_picker = _resolveComponent("el-time-picker");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (reminder, reminderIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: reminder.id || reminder._localKey || reminderIndex,
          class: "border border-slate-200 rounded-xl overflow-hidden"
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, "服务提醒 " + _toDisplayString(reminderIndex + 1), 1), reminder.enabled === false ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已关闭")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [!__props.locked ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "提醒", -1)), _createElementVNode("label", _hoisted_8, [_createElementVNode("input", {
          type: "checkbox",
          class: "form-switch-input",
          checked: reminder.enabled !== false,
          onChange: $event => toggleReminder(reminder)
        }, null, 40, _hoisted_9), _cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1))])])) : _createCommentVNode("", true), !__props.locked || __props.rows.length > 1 ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          onClick: $event => removeReminder(reminderIndex),
          class: "p-1.5 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-colors"
        }, [...(_cache[2] || (_cache[2] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1)]))], 8, _hoisted_10)) : _createCommentVNode("", true)])]), _createElementVNode("div", {
          class: _normalizeClass(["p-4", reminder.enabled === false ? 'opacity-60 pointer-events-none' : ''])
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 提醒事项 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => reminder.reminderItem = $event,
          type: "text",
          class: "form-input w-full",
          placeholder: "请输入提醒事项",
          disabled: reminder.enabled === false,
          onInput: emitTouched
        }, null, 40, _hoisted_12), [[_vModelText, reminder.reminderItem]])]), _createElementVNode("div", null, [_cache[4] || (_cache[4] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 提醒人员 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(UserSelector, {
          modelValue: reminder.receiverUserIds,
          "onUpdate:modelValue": [$event => reminder.receiverUserIds = $event, emitTouched],
          multiple: true,
          placeholder: "请选择提醒人员",
          disabled: reminder.enabled === false
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _cache[5] || (_cache[5] = _createElementVNode("p", {
          class: "mt-1 text-xs text-slate-500"
        }, "默认为订单创建人、执行人及执行人部门负责人，可修改", -1))])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-700"
        }, [_createTextVNode("提醒周期 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_radio_group, {
          modelValue: reminder.repeatType,
          "onUpdate:modelValue": $event => reminder.repeatType = $event,
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            value: "INTERVAL"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("常规", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: "WEEKLY"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("每周", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: "MONTHLY"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("每月", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]), reminder.repeatType === 'INTERVAL' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "首次提醒时间", -1)), _createVNode(_component_el_date_picker, {
          modelValue: reminder.firstReminderTime,
          "onUpdate:modelValue": $event => reminder.firstReminderTime = $event,
          type: "datetime",
          format: "YYYY年MM月DD日 HH:mm",
          "value-format": "YYYY-MM-DDTHH:mm:ss",
          placeholder: "请选择提醒时间",
          class: "form-date",
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]), _createElementVNode("div", _hoisted_17, [_cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "提醒间隔", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => reminder.repeatIntervalValue = $event,
          type: "number",
          min: "1",
          class: "form-input form-control-sm w-20 text-center",
          placeholder: "1",
          disabled: reminder.enabled === false,
          onInput: emitTouched
        }, null, 40, _hoisted_18), [[_vModelText, reminder.repeatIntervalValue, void 0, {
          number: true
        }]]), _createVNode(_component_el_select, {
          modelValue: reminder.repeatIntervalUnit,
          "onUpdate:modelValue": $event => reminder.repeatIntervalUnit = $event,
          class: "w-24 form-select form-control-sm",
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "天",
            value: "DAY"
          }), _createVNode(_component_el_option, {
            label: "小时",
            value: "HOUR"
          }), _createVNode(_component_el_option, {
            label: "分钟",
            value: "MINUTE"
          })]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])])) : reminder.repeatType === 'WEEKLY' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_cache[12] || (_cache[12] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "每周", -1)), _createVNode(_component_el_select, {
          modelValue: reminder.weekDay,
          "onUpdate:modelValue": $event => reminder.weekDay = $event,
          class: "w-28 form-select form-control-sm",
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDayOptions, d => {
            return _createVNode(_component_el_option, {
              key: d.value,
              label: d.label,
              value: d.value
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_el_time_picker, {
          modelValue: reminder.remindTime,
          "onUpdate:modelValue": $event => reminder.remindTime = $event,
          format: "HH:mm",
          "value-format": "HH:mm:ss",
          placeholder: "选择时间",
          class: "form-date form-control-sm",
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [_cache[13] || (_cache[13] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "每月", -1)), _createVNode(_component_el_select, {
          modelValue: reminder.monthDay,
          "onUpdate:modelValue": $event => reminder.monthDay = $event,
          class: "w-28 form-select form-control-sm",
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, d => {
            return _createVNode(_component_el_option, {
              key: d,
              label: `${d}号`,
              value: d
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_el_time_picker, {
          modelValue: reminder.remindTime,
          "onUpdate:modelValue": $event => reminder.remindTime = $event,
          format: "HH:mm",
          "value-format": "HH:mm:ss",
          placeholder: "选择时间",
          class: "form-date form-control-sm",
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _cache[14] || (_cache[14] = _createElementVNode("span", {
          class: "text-xs text-slate-500"
        }, "无该日期时取当月最后一天", -1))])), _createElementVNode("div", _hoisted_21, [_cache[19] || (_cache[19] = _createElementVNode("span", {
          class: "text-sm font-medium text-slate-700"
        }, [_createTextVNode("结束方式 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_radio_group, {
          modelValue: reminder.endType,
          "onUpdate:modelValue": $event => reminder.endType = $event,
          disabled: reminder.enabled === false,
          onChange: emitTouched
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            value: "COUNT"
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("按次数", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: "SERVICE_END"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("服务期结束", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), reminder.endType === 'COUNT' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "最大", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => reminder.maxReminderCount = $event,
          type: "number",
          min: "1",
          class: "form-input form-control-sm w-20 text-center",
          placeholder: "10",
          disabled: reminder.enabled === false,
          onInput: emitTouched
        }, null, 40, _hoisted_23), [[_vModelText, reminder.maxReminderCount, void 0, {
          number: true
        }]]), _cache[18] || (_cache[18] = _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "次", -1))])) : (_openBlock(), _createElementBlock("span", _hoisted_24, "订单服务结束日期后自动停止（需订单填写服务结束日期）"))])])], 2)]);
      }), 128))]), _createElementVNode("button", {
        onClick: addReminder,
        class: "w-full py-3 border-2 border-dashed border-slate-300 rounded-xl text-slate-500 hover:border-primary-400 hover:text-primary-600 hover:bg-primary-50 transition-colors flex items-center justify-center gap-2"
      }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })], -1), _createTextVNode(" 添加服务提醒 ", -1)]))])]);
    };
  }
};